<template>
    <app-layout :nav_type="null">
        <section class="bg-half-170 bg-light d-table w-100">
            <div class="container">
                <div class="row mt-5 justify-content-center">
                    <div class="col-lg-12 text-center">
                        <div class="pages-heading">
                            <h4 class="title mb-0"> {{ item?.title }} </h4>
                        </div>
                    </div>  <!--end col-->
                </div><!--end row-->

                <div class="position-breadcrumb">
                    <nav aria-label="breadcrumb" class="d-inline-block">
                        <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                            <li class="breadcrumb-item"><a href="/">{{ main?.settings?.name }}</a></li>
                            <li class="breadcrumb-item"><a href="#">Page</a></li>
                            <li class="breadcrumb-item active" aria-current="page">{{ item?.title }}</li>
                        </ul>
                    </nav>
                </div>
            </div> <!--end container-->
        </section>
        <div class="position-relative">
            <div class="shape overflow-hidden text-color-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <section class="section">
            <div class="container">
                <!--                    <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">-->
                <!--                        <div class="position-relative">-->
                <!--                            <img src="assets/images/company/about.jpg" class="rounded img-fluid mx-auto d-block" alt="">-->
                <!--                            <div class="play-icon">-->
                <!--                                <a href="#!" data-type="youtube" data-id="yba7hPeTSjk"-->
                <!--                                   class="play-btn lightbox border-0">-->
                <!--                                    <i class="mdi mdi-play text-primary rounded-circle shadow"></i>-->
                <!--                                </a>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                    </div>&lt;!&ndash;end col&ndash;&gt;-->

                <div class="text-center">
                    <img v-if="item.image" :src="item.image" class="mw-100 rounded rounded-4 col-md-8 mb-4">

                </div>

                <div class="section-title ms-lg-4">
                    <div v-html="item.content"></div>
                </div>
            </div><!--end container-->

            <!--end container-->
        </section>
    </app-layout>
</template>

<script>
import {useToast} from "vue-toastification";
import AppLayout from "../../app-layout.vue";
import {useHead} from "@vueuse/head";

const toast = useToast();

export default {
    components: {AppLayout},
    data() {
        return {
            item: []
        }
    },
    created() {

        console.log(this.item?.title);


        const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

        axios.get(`pages/${this.$route.params.id}`, {}).then(response => {

            this.item = response.data.data;

            useHead({
                title: this.item?.title,
            })
            toast.dismiss(id);
        }, response => {
            toast.dismiss(id);
        });

    },
}
</script>
